import React, { Component } from 'react';
import { Row, Col, Icon } from 'antd';

export default class Code403 extends Component {
    constructor(props) { super(props); }
    render() {
        const { styleProps } = this.props;
        return (
            <div>
                <div {...styleProps.textDiv}>
                    <Icon type='exclamation-circle-o' style={{ marginRight: '6px' }} />
                    {'Unable to login.'}
                </div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '4px' }}>
                    <Col span={14}>
                        {'Invalid username and/or password.'}
                    </Col>
                </Row>
            </div>
        );
    }
}
